import {
  useContext,
  createContext,
  ReactNode,
  useState,
  useCallback,
} from 'react';

interface ICreateReportProviderProps {
  children: ReactNode;
}

type General = {
  consult: string;
};

type CreateReportContextData = {
  general: General;
  updateGeneral: (value: General) => void;
};

const CreateReportContext = createContext({} as CreateReportContextData);

export function CreateReportProvider({ children }: ICreateReportProviderProps) {
  const [general, setGeneral] = useState<General>(() => {
    const createReportGeneral = localStorage.getItem(
      '@okton:create-report:general',
    );

    if (createReportGeneral) {
      return JSON.parse(createReportGeneral);
    }

    return {} as General;
  });

  const updateGeneral = useCallback((value: General) => {
    localStorage.setItem('@okton:create-report:general', JSON.stringify(value));
    setGeneral(value);
  }, []);

  return (
    <CreateReportContext.Provider value={{ general, updateGeneral }}>
      {children}
    </CreateReportContext.Provider>
  );
}

export const useCreateReport = () => useContext(CreateReportContext);
